// constants/scheduleConstants.js
export const SCHEDULE_GROUPS = {
    BRIDGE: 'fix_and_flips',
    RENTAL: 'investment_properties_owned',
    PRIMARY: 'primary_residence'
};

export const GROUP_DISPLAY_NAMES = {
    [SCHEDULE_GROUPS.PRIMARY]: 'Investment Properties Owned',
    [SCHEDULE_GROUPS.RENTAL]: 'Rental',
    [SCHEDULE_GROUPS.BRIDGE]: 'Bridge'
};

export const EMPTY_ROWS_COUNT = 5;

export const FIELD_MAPPING = {
    'address': 'address',
    'titleName': 'title_name',
    'ownershipPercent': 'ownership_percent',
    'purchaseDate': 'purchaseDate',
    'currentMarketValue': 'current_market_value',
    'lenderName': 'lender_name',
    'totalMortgageAmount': 'total_mortgage_amount',
    'purchasePrice': 'purchase_price',
    'rehabBudget': 'rehab_budget',
    'salePrice': 'sale_price',
    'saleDate': 'sale_date',
    'mortgagePayment': 'mortgage_payment',
    'rentAmount': 'rent_amount',
};

export const TABLE_CONFIG = {
    enableColumnResizing: true,
    columnResizeMode: 'onChange',
};
